import { ColDef } from 'ag-grid-enterprise';
import { RemoveSyncOptionCell } from './OptionCell';
import { FolderType } from './colDefsFundsTable';

export const colDefsFoldersTable: ColDef<FolderType>[] = [
  {
    field: 'folderName',
    headerName: 'Folder Name',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
    resizable: false,
  },
  {
    field: 'options',
    headerName: '',
    cellRenderer: RemoveSyncOptionCell,
    cellClass: 'flex align-items-center justify-content-center',
    type: 'w200',
  },
];
